<h3 class="title" voxelHeaderTitle>{{title}}</h3>
<hr class="divider">
<div class="container-stepper" *ngIf="stepsList && stepsList.length > 0">
    <div class="stepper-labels">
        <div class="stepper-label"><em>{{labelName}}</em></div>
        <div class="stepper-label"><small>{{labelStep}}</small></div>
    </div>
    <div class="stepper">
        <voxel-progress-bar [fill]="progress(currentStep)"></voxel-progress-bar>
    </div>
</div>